import dateFnsParseISO from "date-fns/parseISO";
import dateFnsFormat from "date-fns/format";

class ParseISOMismatch extends Error {
    constructor(input: string, parsed: number, std: number) {
        super(`input=${JSON.stringify(input)} mismatched: parsed=${parsed} std=${std}`);
        this.name = "ParseISOMismatch";
    }
}

export function parseISO(date: string) {
    const parsed = dateFnsParseISO(date);
    const std = new Date(date);
    if (+parsed !== +std) {
        reportError(new ParseISOMismatch(date, +parsed, +std));
    }
    return parsed;
}

export function parseIsoDate_(date: string) {
    const match = date.match(/^(\d+)-(\d+)-(\d+)$/);
    if (!match) {
        throw new RangeError(`Invalid date format: ${date}`);
    }

    const year = parseInt(match[1]);
    const month = parseInt(match[2]) - 1; // Date ctor takes "month index"
    const day = parseInt(match[3]);
    return new Date(year, month, day);
}

export function parseISODate(date: string) {
    const parsed = dateFnsParseISO(date);
    const std = parseIsoDate_(date);
    if (+parsed !== +std) {
        reportError(new ParseISOMismatch(date, +parsed, +std));
    }
    return parsed;
}

class FormatISOMismatch extends Error {
    constructor(date: Date, formatted: string, std: string) {
        super(`input=${date} mismatched: formatted=${formatted} std=${std}`);
        this.name = "FormatISOMismatch";
    }
}

function fmt02(num: number) {
    return num.toString().padStart(2, "0");
}

export function formatISODate_(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${fmt02(month)}-${fmt02(day)}`;
}

export function formatISODate(date: Date) {
    const formatted = dateFnsFormat(date, "yyyy-MM-dd");
    const std = formatISODate_(date);
    if (formatted !== std) {
        reportError(new FormatISOMismatch(date, formatted, std));
    }
    return formatted;
}

export function getYear() {
  return new Date().getFullYear();
}
